import { render } from "./SignUpModal.vue?vue&type=template&id=cfcfb48c"
import script from "./SignUpModal.vue?vue&type=script&lang=js"
export * from "./SignUpModal.vue?vue&type=script&lang=js"

import "./SignUpModal.vue?vue&type=style&index=0&id=cfcfb48c&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__